// CUSTOM FUNCTION - Check data for matching data object
export const findExternalCoinData = (coinData: any, id: string) => {
  if (coinData) {
    return coinData.find((coin: any) => coin.id === id);
  }
};
